/**
 * Bankers rounding is a more fair way to round money as it has no bias. When a
 * number has equal distance to round both directions it will round to the
 * nearest even number.
 **/
export function bankersRound(amount: number): number {
  const remainder = amount % 1;

  if (remainder !== 0.5) {
    return Math.round(amount);
  }

  const floored = Math.floor(amount);

  if (isEven(floored)) {
    return floored;
  }

  return floored + 1;
}

function isEven(amount: number) {
  return amount % 2 === 0;
}
